import { render, staticRenderFns } from "./PreLogout.vue?vue&type=template&id=031128a3&scoped=true&"
import script from "./PreLogout.vue?vue&type=script&lang=js&"
export * from "./PreLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031128a3",
  null
  
)

export default component.exports